import { component } from 'picoapp';
import { addVariant } from '@/lib/cart.js';
import { gsap } from 'gsap';

export default component((node, ctx) => {
  const json = JSON.parse(node.querySelector('.js-product-json').innerHTML);
  const form = node.querySelector('form');
  const submitButton = node.querySelector('[data-live-add-to-cart]');

  const { selectedVariant, product } = json;
  let currentVariant = product.variants.filter(v => v.id === selectedVariant)[0];

  form.addEventListener('submit', e => {
    e.preventDefault();
    
    // Show active/progress state on button
    gsap.set(submitButton, { opacity: 0.3, pointerEvents: 'none' });
    currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.selectedVariant.value))[0];
    addVariant(
      currentVariant,
      form.elements.quantity.value,
      getLineItemProperties());
    // Once cart is updated, set button state back to normal
    ctx.on('cart:updated', () => {
      gsap.to(submitButton, { opacity: 1, pointerEvents: 'auto' });
    });
  });

  const getLineItemProperties = () => {
    const properties = {};

    $('.js-line-item').each((index, item) => {
      const product = item.dataset.productTitle;
      const qty = $(item).find('.js-quantity-input').val();

      if (qty > 0) properties[product] = qty;
    });

    return properties;
  };
});
